<template>
  <card
    :bodyClasses="['body', {'closed': !expanded}]"
    shadow
  >
    <div slot="header" class="row scorecard-header">
      <div class="col-auto d-flex align-items-center" @click="expanded = !expanded">
        <div class="avatar-group d-flex align-items-center">
          <div
            class="avatar rounded-circle"
            v-for="player in profiles" :key="player.id"
            v-tooltip="player.user.Name"
          >
            <img :src="getAvatarUrl(player.user)" />
          </div>
        </div>
      </div>
      <div class="col d-flex align-items-center" @click="expanded = !expanded">
        <h3 class="mb-0">{{team.Name}}</h3>
      </div>
      <div class="col-auto text-right d-flex align-items-center justify-content-end">
        <div class="button-area"  v-if="!loading">
          <base-button
            type="success"
            size="sm"
            @click="save"
            v-if="editing"
          >
            Save
          </base-button>
          <base-button
            type="danger"
            size="sm"
            v-if="editing"
            @click="discard"
          >
            Cancel
          </base-button>

        </div>
        <div class="loader" v-if="loading">
          Loading
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <i class="fa fa-chevron-down" v-if="!expanded" @click="expanded = !expanded"/>
        <i class="fa fa-chevron-up" v-else @click="expanded = !expanded"/>
      </div>
    </div>
    <div class="row align-items-end d-flex">
      <div class="col-md-6">
        <base-input
          class="mb-0"
          label="Total"
          v-model="model.total"
          input-classes="form-control-alternative"
          type="number"
        />
      </div>
      <div class="col-md-6">
        <base-input
          class="mb-0"
          label="Thru"
          v-model="model.thru"
          input-classes="form-control-alternative"
          type="text"
        />
      </div>
    </div>

    <div class="row align-items-end d-flex mt-3">
      <div class="col-md-3" v-if="league.showCTP">
        <base-input
          label="CTP"
          v-model="model.closest_to_pin"
          input-classes="form-control-alternative"
          type="number"
        />
      </div>
      <div class="col-md-3" v-if="league.showCTP">
        <base-input
          label="Player"
        >
          <MultiselectReturnId
            v-model="model.ctp_player"
            :options="users"
            class="shadow"
            track-by="id"
            label="Name"
            selectLabel=""
            deselectLabel=""
          />
        </base-input>
      </div>
      <div class="col-md-3" v-if="league.showLD">
        <base-input
          label="Longest Drive"
          v-model="model.long_drive"
          input-classes="form-control-alternative"
          type="number"
        />
      </div>
      <div class="col-md-3" v-if="league.showLD">
        <base-input
          label="Player"
        >
          <MultiselectReturnId
            v-model="model.ld_player"
            :options="users"
            class="shadow"
            track-by="id"
            label="Name"
            selectLabel=""
            deselectLabel=""
          />
        </base-input>
      </div>
    </div>
    <div class="row align-items-end d-flex mt-3">
      <div class="col-md-12">
        <base-input
          class="mb-0"
          label="Note"
          v-model="model.note"
          input-classes="form-control-alternative"
          type="text"
        />
      </div>
    </div>
  </card>
</template>
<script>
import AvatarHelper from '@/helpers/Avatars';
import ErrorHandler from '@/helpers/AuthError';
import MultiselectReturnId from '@/components/MultiselectReturnId.vue';

export default {
  name: 'PlayoffScoreCard',
  props: {
    team: Object,
    week: Object,
    league: Object,
  },
  components: {
    MultiselectReturnId,
  },
  data() {
    return {
      edited: false,
      deleting: false,
      expanded: false,
      loading: false,
      profiles: [],
      scorecard: {
        id: -1,
        thru: '',
        total: null,
        note: '',
        long_drive: null,
        ld_player: null,
        closest_to_pin: null,
        ctp_player: null,
      },
      model: {
        thru: '',
        total: null,
        note: '',
        long_drive: null,
        ld_player: null,
        closest_to_pin: null,
        ctp_player: null,
      },
    };
  },
  computed: {
    editing() {
      if (String(this.scorecard.total) === String(this.model.total)
            && String(this.scorecard.thru) === String(this.model.thru)
            && String(this.scorecard.note) === String(this.model.note)
            && String(this.scorecard.ctp_player) === String(this.model.ctp_player)
            && String(this.scorecard.ld_player) === String(this.model.ld_player)
            && String(this.scorecard.long_drive) === String(this.model.long_drive)
            && String(this.scorecard.closest_to_pin) === String(this.model.closest_to_pin)) {
        return false;
      }
      return true;
    },
    users() {
      return this.profiles.map(profile => profile.user);
    },
  },
  mounted() {
    this.getPlayerProfiles();
    this.getScorecard();
  },
  watch: {
    week() {
      this.getPlayerProfiles();
      this.getScorecard();
    },
  },
  sockets: {
    updated_playoff_scorecard(value) {
      console.log("WEBSOCKET UPDATE", value);
      if (this.scorecard.id === -1
          && value.team.id === this.team.id
          && value.week.id === this.week.id
          && value.leagueId === this.league.id
      ) {
        this.scorecard.id = value.id;
        this.scorecard.thru = value.thru;
        this.scorecard.total = value.total;
        this.scorecard.note = value.note;
        this.scorecard.long_drive = value.long_drive ? value.long_drive.ld : null;
        this.scorecard.closest_to_pin = value.closest_to_pin ? value.closest_to_pin.ctp : null;
        this.scorecard.ld_player = value.long_drive ? value.long_drive.player.id : null;
        this.scorecard.ctp_player = value.closest_to_pin ? value.closest_to_pin.player.id : null;
        this.model.thru = value.thru;
        this.model.total = value.total;
        this.model.note = value.note;
        this.model.long_drive = value.long_drive ? value.long_drive.ld : null;
        this.model.closest_to_pin = value.closest_to_pin ? value.closest_to_pin.ctp : null;
        this.model.ld_player = value.long_drive ? value.long_drive.player.id : null;
        this.model.ctp_player = value.closest_to_pin ? value.closest_to_pin.player.id : null;
      }
      if (parseInt(value.id, 10) === parseInt(this.scorecard.id, 10)) {
        this.scorecard.thru = value.thru;
        this.scorecard.total = value.total;
        this.scorecard.note = value.note;
        this.scorecard.long_drive = value.long_drive ? value.long_drive.ld : null;
        this.scorecard.closest_to_pin = value.closest_to_pin ? value.closest_to_pin.ctp : null;
        this.scorecard.ld_player = value.long_drive ? value.long_drive.player.id : null;
        this.scorecard.ctp_player = value.closest_to_pin ? value.closest_to_pin.player.id : null;
        this.model.thru = value.thru;
        this.model.total = value.total;
        this.model.note = value.note;
        this.model.long_drive = value.long_drive ? value.long_drive.ld : null;
        this.model.closest_to_pin = value.closest_to_pin ? value.closest_to_pin.ctp : null;
        this.model.ld_player = value.long_drive ? value.long_drive.player.id : null;
        this.model.ctp_player = value.closest_to_pin ? value.closest_to_pin.player.id : null;
      }
    },
  },
  methods: {
    getAvatarUrl(user) {
      return AvatarHelper.getAvatar(user);
    },
    getPlayerProfiles() {
      this.axios
        .get(`/teamprofiles?team_eq=${this.team.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.profiles = response.data;
        });
    },
    getScorecard() {
      this.axios
        .get(`/playoffscorecards?team_eq=${this.team.id}&week_eq=${this.week.id}&league_eq=${this.league.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.length > 0) {
            this.scorecard.id = response.data[0].id;
            this.scorecard.thru = response.data[0].thru;
            this.scorecard.total = response.data[0].total;
            this.scorecard.note = response.data[0].note;
            this.scorecard.long_drive = response.data[0].long_drive;
            this.scorecard.closest_to_pin = response.data[0].closest_to_pin;
            this.scorecard.ld_player = response.data[0].ld_player ? response.data[0].ld_player.id : null;
            this.scorecard.ctp_player = response.data[0].ctp_player ? response.data[0].ctp_player.id : null;
            this.model.thru = response.data[0].thru;
            this.model.total = response.data[0].total;
            this.model.note = response.data[0].note;
            this.model.long_drive = response.data[0].long_drive;
            this.model.closest_to_pin = response.data[0].closest_to_pin;
            this.model.ld_player = response.data[0].ld_player ? response.data[0].ld_player.id : null;
            this.model.ctp_player = response.data[0].ctp_player ? response.data[0].ctp_player.id : null;
          } else {
            this.scorecard.id = -1;
            this.scorecard.thru = '';
            this.scorecard.total = null;
            this.scorecard.note = '';
            this.scorecard.long_drive = null;
            this.scorecard.closest_to_pin = null;
            this.scorecard.ld_player = null;
            this.scorecard.ctp_player = null;
            this.model.thru = '';
            this.model.total = null;
            this.model.note = '';
            this.model.long_drive = null;
            this.model.closest_to_pin = null;
            this.model.ld_player = null;
            this.model.ctp_player = null;
          }
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    save() {
      this.axios
        .post('/playoffscorecards/createorupdate', {
          total: this.model.total,
          thru: this.model.thru,
          note: this.model.note,
          team: this.team.id,
          league: this.league.id,
          week: this.week.id,
          long_drive: this.model.long_drive,
          closest_to_pin: this.model.closest_to_pin,
          ctp_player: this.model.ctp_player ? this.model.ctp_player : null,
          ld_player: this.model.ld_player ? this.model.ld_player : null,
        },
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.scorecard.id = response.data.id;
          this.scorecard.thru = response.data.thru;
          this.scorecard.total = response.data.total;
          this.scorecard.note = response.data.note;
          this.scorecard.long_drive = response.data.long_drive;
          this.scorecard.closest_to_pin = response.data.closest_to_pin;
          this.scorecard.ld_player = response.data.ld_player ? response.data.ld_player.id : null;
          this.scorecard.ctp_player = response.data.ctp_player ? response.data.ctp_player.id : null;
          this.expanded = false;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    discard() {
      this.model.total = this.scorecard.total;
      this.model.thru = this.scorecard.thru;
      this.model.note = this.scorecard.note;
      this.model.ctp_player = this.scorecard.ctp_player;
      this.model.ld_player = this.scorecard.ld_player;
      this.model.long_drive = this.scorecard.long_drive;
      this.model.closest_to_pin = this.scorecard.closest_to_pin;
    },
  },
};
</script>
<style lang="scss" scoped>
  .loader{
    text-transform: uppercase;
    font-size: .9rem;
    font-weight: 600;
    opacity: .6;
    padding-right: .5rem;
  }
  .avatar {
    width: 40px;
    height: 40px;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .player-card{
    overflow: hidden;
  }
  .status-badge{
    margin-left: 1rem;
    margin-top: .2rem;
  }
  .button-area{
    margin-right: 1rem;
  }
</style>
<style lang="scss">
  .body{
    transition: all .15s;
  }
  .closed{
    height: 0;
    opacity: 0;
    visibility: none;
    padding: 0;
  }

  .checkbox-short{
    padding-left: 2rem;

    .custom-control-label::before{
      left: -2rem;
    }
    .custom-control-label::after{
      left: -2rem;
    }
  }

  .scorecard-header{
    margin: -.5rem -1.5rem;
  }
</style>
